import { colorNeutralBackground2, colorNeutralBackground3, colorNeutralForeground3, display, spacingHorizontalM, spacingHorizontalXS, spacingHorizontalXXL, spacingHorizontalXXXL, spacingVerticalM, spacingVerticalS, spacingVerticalXS, spacingVerticalXXL } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
/** Wizard styles
 * @public
 */
export const styles = css `
  ${display("block")}

  :host {
    height: 100%;
    width: 100%;
    --wizard-overflow-tablist-width: calc(
      ${spacingHorizontalXXXL} + ${spacingHorizontalXXXL} +
        ${spacingHorizontalXXXL}
    );
    --wizard-overflow-step-width: calc(
      ${spacingHorizontalXXL} + ${spacingHorizontalXS}
    );
    --wizard-scrollbar-radius: ${spacingHorizontalXS};
    --wizard-scrollbar-spacing: ${spacingHorizontalXS};
    --wizard-scrollbar-thumb-color: ${colorNeutralForeground3};
    --wizard-scrollbar-track-color: ${colorNeutralBackground3};
  }

  :host(.overflow) .steps {
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: scroll;
    padding: ${spacingVerticalXXL} ${spacingHorizontalXXL};
  }

  .steps {
    background-color: ${colorNeutralBackground3};
    box-sizing: border-box;
    padding: ${spacingVerticalXXL} ${spacingHorizontalXXL};
    position: sticky;
    top: 0;
    inset-inline: 0;
    width: 100%;
    z-index: 9;
    display: flex;
    flex-direction: row;
  }

  .wizard {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .title {
    color: ${colorNeutralForeground3};
  }

  .panels-container {
    background: ${colorNeutralBackground2};
  }

  .button-container {
    gap: ${spacingHorizontalM};
    order: 1;
    display: flex;
    width: 100%;
    justify-self: flex-end;
    justify-self: self-end;
    justify-content: flex-end;
  }

  .toolbar {
    display: var(--wizard-toolbar-display, flex);
    gap: ${spacingVerticalXS};
    flex-direction: column;
    justify-content: space-between;
    padding-block-start: ${spacingVerticalM};
    padding-inline: ${spacingHorizontalXXL};
    padding-block-end: 0;
    margin-bottom: ${spacingVerticalS};
  }
  .title {
    order: 2;
  }

  .steps::-webkit-scrollbar-track {
    background-color: var(--wizard-scrollbar-track-color);
    border-radius: var(--wizard-scrollbar-radius);
  }

  .steps::-webkit-scrollbar-thumb {
    background-color: var(--wizard-scrollbar-thumb-color);
    border-radius: var(--wizard-scrollbar-radius);
    margin-inline-end: var(--wizard-scrollbar-spacing);
  }

  .steps::-webkit-scrollbar-button {
    display: none; /* Hide scrollbar arrows */
  }

  @media (min-width: 32.5rem /* @design-token-ok */) {
    :host {
      padding-top: 0;
    }
    .toolbar {
      flex-direction: row;
      margin-bottom: 0;
      gap: 0;
    }
    .panels-container {
      width: 100%;
    }
    .wizard {
      flex-direction: row;
    }
    .title {
      order: 1;
      flex-shrink: 0;
    }
    .buttons-container {
      order: 2;
      width: fit-content;
    }
    .steps {
      padding: ${spacingVerticalXXL} ${spacingHorizontalXXL};
      position: relative;
      max-width: var(--wizard-overflow-tablist-width);
    }
    .steps {
      flex-direction: column;
    }
    :host(.overflow) .steps {
      width: fit-content;
      justify-content: flex-start;
      align-items: center;
      overflow-x: unset;
      overflow-y: unset;
      width: var(--wizard-overflow-step-width);
    }
  }

  @media (min-width: 63.9375rem /* @design-token-ok */) {
    .steps {
      max-width: var(
        --wizard-tablist-width,
        var(--wizard-overflow-tablist-width)
      );
      width: var(--wizard-tablist-width, var(--wizard-overflow-tablist-width));
      padding: ${spacingVerticalXXL} ${spacingHorizontalXXXL}
        ${spacingVerticalXXL} ${spacingHorizontalXXL};
    }
    :host(.overflow) .steps {
      width: fit-content;
    }
  }
`;
//# sourceMappingURL=wizard.styles.js.map